import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { CurrencyProvider } from './context/CurrencyContext';
import { Provider } from 'react-redux'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "line-awesome/dist/line-awesome/css/line-awesome.css";
import "./global.css";
import { createStore, combineReducers, applyMiddleware } from 'redux';
import inactiveUser from './store/reducer/inactiveUser'
import logo from './store/reducer/logoImage';

import thunk from 'redux-thunk';

const rootReducer = combineReducers({
  headUser: inactiveUser,
  logo:  logo
});
const store = createStore(rootReducer, applyMiddleware(thunk));

ReactDOM.render(

  <BrowserRouter>
    <CurrencyProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </CurrencyProvider>
  </BrowserRouter>
  ,
  document.getElementById("root")
);
